import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { DataSourceRequestState, toDataSourceRequestString } from '@progress/kendo-data-query';

@Injectable({
  providedIn: 'root'
})
export class ClientDirectoryService {

  constructor(private readonly _http: HttpClient) { }

  getClientDirectory(state: DataSourceRequestState, SearchText: any) {
    let queryStr = `${toDataSourceRequestString(state)}`;
    return this._http.get<any>(`${environment.endPoint}/api/Company/GetDoctorDirectory?${queryStr}&SearchText=${SearchText}`);
  }

  updateClientDirectory(data: any) {
    return this._http.post(`${environment.endPoint}/api/Company/UpdateDoctorDirectory`, data);
  }
  CreateClientDirectory(data: any) {
    return this._http.post(`${environment.endPoint}/api/Company/AddDoctorDirectory`, data);
  }

  getServicesAllData() {
    return this._http.get(`${environment.endPoint}/api/CompanyServices/GetServices`);
  }

  CreateService(data: any) {
    return this._http.post(`${environment.endPoint}/api/CompanyServices/Create`, data);
  }

  UpdateDirectoryStatus(id: any, status: boolean) {
    return this._http.put(`${environment.endPoint}/api/Company/UpdateDirectoryStatus?id=${id}&status=${status}`, null);
  }

  getSpecializationAllData() {
    return this._http.get(`${environment.endPoint}/api/CompanySpecialization/GetSpecializations`);
  }

  CreateSpecialization(data: any) {
    return this._http.post(`${environment.endPoint}/api/CompanySpecialization/Create`, data);
  }

  matchEmailName(Email: any) {
    let model = { Email: Email }
    return this._http.post(
      `${environment.endPoint}/api/Company/CheckEmailExists`,
      model
    );
  }

  matchEmailNameById(Email: any, companyId: any) {
    return this._http.post(
      `${environment.endPoint}/api/Company/CheckEmailExistsWithId?Email=${Email}&companyId=${companyId}`,
      ""
    );
  }

  convertDirectorytoDomain(data: any) {
    return this._http.post(`${environment.endPoint}/api/Company/CreateDomainOfDoctorDirectory`, data);
  }

  matchClinicName(CompanyName: any, companyId: any) {
    return this._http.post(
      `${environment.endPoint}/api/Company/CheckClinicNameExistsWithId?ClinicName=${CompanyName}&companyId=${companyId}`,
      ""
    );
  }

  matchDomain(CompanyCode: any) {
    return this._http.post(
      `${environment.endPoint}/api/Company/CheckCompanyCodeExists?CompanyCode=${CompanyCode}`,
      ""
    );
  }

  getCountry() {
    return this._http.get<any>(
      `${environment.endPoint}/api/Currency/Get`
    );
  }

}
